require('./build.scss');

var vehicleMake = window.EDM.PageValues.vehicle.make.niceName;
var isMazda = vehicleMake && vehicleMake === 'mazda';
if (isMazda) {
    var data = require('./build-data');
}

var controller = require('src/interlock/core-page/build/controller');
var styleId = window.EDM.PageValues.vehicle.style.id;

var adRefresh = require('src/interlock/product/ads/ad-manager/ad-retarget-refresh-manager');
var gptSlotIniter = require('src/interlock/product/ads/ad-manager/gpt-slot-initer');

$('.core-build-module').each(function(index, component) {
    var $component = $(component),
        $carouselBtnGroup = $component.find('.swatch-outer'),
        $carouselActiveSlides = $component.find('.owl-item'),
        $legacyLinkout = $component.find('.legacy-linkout'),
        $buildOwlCarousel = $component.find('.owl-carousel');

    $carouselBtnGroup.on('click', function(e){
        controller.swatchClickHandler(e, $buildOwlCarousel, $carouselBtnGroup, $component);
        if (isMazda) {
            data.getVehicle(styleId);
        }
    });

    $carouselActiveSlides.on('click', function(e){
        if(!$(e.currentTarget).hasClass('center')) {
            controller.triggerSlide(e.currentTarget, $buildOwlCarousel);
        }
    });

    $buildOwlCarousel.on('changed.owl.carousel', function(e) {
        controller.slideChangeHandler(e, $carouselBtnGroup, $component);
        refreshDeepLinkAd($component);
    });

    $legacyLinkout.on('click', function(){
        controller.fireLinkoutTracking($component);
    });
});

/**
 * Refreshes ad units enclosed in container with class .deep-link-ad (DFP) and .build-deep-link (hard-coded, Mazda)
 * @param $component
 */
function refreshDeepLinkAd($component) {
    var slot = gptSlotIniter.getAdIdToSlot(),
        id = $component.find('.build-deep-link .punit > div').attr('id')
    || $component.find('.deep-link-ad .punit > div').attr('id');
    id && adRefresh.refreshAdSlot(slot[id]);
}

if (isMazda) {
    $(document).ready(function() {
        data.getVehicle(styleId);
    });
}




//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/build/build.js
// module id = 158
// module chunks = 0 1 23